import { isWeekend } from 'date-fns';
import { TZDate } from '@date-fns/tz';

export const isSupportOnlineUK = (date: Date = new Date()): boolean => {
  const londonDate = new TZDate(date, 'Europe/London');

  const hour = londonDate.getHours();
  const minute = londonDate.getMinutes();
  const isWeekday = !isWeekend(date);

  // 08:00 inclusive to 18:00 exclusive in London local time
  const isInHours = (hour > 8 || (hour === 8 && minute >= 0)) && hour < 18;

  return isWeekday && isInHours;
};
